import React, { ChangeEventHandler, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InputWrapper from "./input-wrapper";
interface TextboxProps {
  onChange?: ChangeEventHandler<HTMLInputElement>;
  name: string;
  label: string;
}

const Filebox = React.forwardRef<HTMLInputElement, TextboxProps>(
  ({ onChange, name, label }, ref) => {
    const [fileName, setFileName] = useState("");

    const handleChange: (
      f: ChangeEventHandler<HTMLInputElement> | undefined
    ) => ChangeEventHandler<HTMLInputElement> = (f1) => {
      const f0: ChangeEventHandler<HTMLInputElement> = (e) => {
        if (e.target.files && e.target.files[0])
          setFileName(e.target.files[0].name);
      };

      const f: ChangeEventHandler<HTMLInputElement> = (e) => {
        f0(e);
        f1 && f1(e);
      };

      return f;
    };

    return (
      <InputWrapper label={label}>
        <label
          htmlFor={name}
          className="relative block bg-white h-32 border border-gray-300 rounded-md cursor-pointer transition duration-300 ease-in-out hover:bg-orange-100"
        >
          <input
            type="file"
            id={name}
            name={name}
            ref={ref}
            className="absolute hidden"
            onChange={handleChange(onChange)}
            accept="image/*"
          />
          <div className="flex flex-col items-center justify-center h-full px-4">
            <FontAwesomeIcon
              icon="upload"
              className="text-orange-500 w-10 h-10 mb-2"
            />
            <span className="text-gray-600">
              {fileName || "Drag and Drop a file here"}
            </span>
          </div>
        </label>
      </InputWrapper>
    );
  }
);

export default Filebox;
